import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { FaEnvelope, FaPhone, FaFacebook, FaTwitter, FaLinkedin, FaInstagram, FaYoutube } from 'react-icons/fa';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="bg-dark text-light py-5 mt-auto">
      <Container>
        <Row>
          <Col md={4} className="mb-4">
            <h4 className="mb-3">IT World</h4>
            <p className="text-light">
              Full-stack development and IT software solutions. 
              We build innovative apps and provide trusted software licenses.
            </p>
          </Col>
          <Col md={2} className="mb-4">
            <h5 className="mb-3">Services</h5>
            <ul className="list-unstyled">
              <li className="mb-2"><a href="#services" className="text-light text-decoration-none">Web Development</a></li>
              <li className="mb-2"><a href="#services" className="text-light text-decoration-none">Mobile Apps</a></li>
              <li className="mb-2"><a href="#services" className="text-light text-decoration-none">Desktop Apps</a></li>
              <li className="mb-2"><Link to="/products" className="text-light text-decoration-none">Software Products</Link></li>
            </ul>
          </Col>
          <Col md={2} className="mb-4">
            <h5 className="mb-3">Quick Links</h5>
            <ul className="list-unstyled">
              <li className="mb-2"><Link to="/" className="text-light text-decoration-none">Home</Link></li>
              <li className="mb-2"><Link to="/about" className="text-light text-decoration-none">About Us</Link></li>
              <li className="mb-2"><Link to="/contact" className="text-light text-decoration-none">Contact Us</Link></li>
              <li className="mb-2"><Link to="/products" className="text-light text-decoration-none">Products</Link></li>
            </ul>
          </Col>
          <Col md={2} className="mb-4">
            <h5 className="mb-3">Legal</h5>
            <ul className="list-unstyled">
              <li className="mb-2"><Link to="/privacy-policy" className="text-light text-decoration-none">Privacy Policy</Link></li>
              <li className="mb-2"><Link to="/terms" className="text-light text-decoration-none">Terms of Use</Link></li>
              <li className="mb-2"><Link to="/refund-policy" className="text-light text-decoration-none">Refund Policy</Link></li>
            </ul>
          </Col>
          <Col md={2} className="mb-4">
            <h5 className="mb-3">Contact Us</h5>
            <p className="text-light mb-2">
              <FaPhone className="me-2" /> 9561306384
            </p>
            <p className="text-light mb-2">
              <FaEnvelope className="me-2" /> itworldwani@gmail.com
            </p>
            <p className="text-light mb-3">Mon-Sat, 11am-7pm</p>
            <div className="social-icons">
              <a href="https://www.facebook.com/itworldwani/" className="text-light me-3"><FaFacebook size={24} /></a>
              { <a href="https://www.youtube.com/@onirsolutions" className="text-light me-3"><FaYoutube size={24} /></a> }
              <a href="https://www.instagram.com/itworldwani/" className="text-light me-3"><FaInstagram size={24} /></a>
            </div>
          </Col>
        </Row>
        <hr className="border-secondary my-4" />
        <Row>
          <Col className="text-center">
            <p className="mb-0 text-muted">&copy; 2025 IT World. All rights reserved.</p>
          </Col>
        </Row>
      </Container>
    </footer>
  );
};

export default Footer;
